import SearchOrganicPaidOverviewCompareDataFetcherFactory from "app/components/widget/widget-fetchers/SearchOrganicPaidOverviewCompareDataFetcher";
import { TableWidget } from "app/components/widget/widget-types/TableWidget";

export class SearchOrganicPaidOverviewTableWidget extends TableWidget {
    static getWidgetMetadataType() {
        return "SearchOrganicPaidOverviewTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getWidgetDashboardType() {
        return "Table";
    }

    constructor() {
        super();
    }

    private dataFetcherFactory() {
        return SearchOrganicPaidOverviewCompareDataFetcherFactory;
    }

    public getFetcherFactory() {
        return this.dataFetcherFactory();
    }
}

SearchOrganicPaidOverviewTableWidget.register();
